import { formatMessage } from "../../helpers/LanguageHelper";
import { CopyCutPasteMessagePanelProps } from "../../../components/layout/CopyCutPasteMessagePanel";

export type PanelSuccessMsgType = "COPIED_SUCCESSFULLY";

type SuccessObjDataType = Record<PanelSuccessMsgType, CopyCutPasteMessagePanelProps>;

export const SUCCESS_INFO: SuccessObjDataType = {
  COPIED_SUCCESSFULLY: {
    title: formatMessage("cof.base.copy"),
    alt: formatMessage("cof.cutcopypaste.message.success.copiedsuccessfully"),
    imageSrc: "/assets/CopiedSuccessfully3x.png",
    caption: formatMessage("cof.cutcopypaste.message.success.copiedsuccessfully"),
    message: formatMessage("cof.cutcopypaste.message.success.copiedsuccessfully.suggestion"),
  },
} as const;
